import { PositiveColors } from '@picsart/design-system/foundation/colors';
import { TypographyT5 } from '@picsart/design-system/foundation/typography';

import {
  Button,
  ButtonElementTypes,
  ButtonSkinTertiary,
} from '@picsart/design-system/components/Button';
import { Text } from '@picsart/design-system/components/Text';

import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { IconColor } from '@picsart/design-system/foundation/icons/IconColor';

import { useTranslator } from '@picsart/rc/services/localization';

import { colors, ColorsEnum, dataTestIds } from '../constants';
import { ColorItemProps } from './types';
import useStyles from './styles';

const ColorItem = ({ colorName }: ColorItemProps) => {
  const classes = useStyles();
  const translate = useTranslator();

  const color = colors.find(item => item.value === colorName);
  const colorHex = ColorsEnum?.[color?.value];
  const href = `/templates/${color?.value}`;

  return (
    <Button
      href={href}
      key={color?.value}
      skin={ButtonSkinTertiary}
      tag={ButtonElementTypes.Link}
      data-pulse-name={color?.label}
      dataTestId={dataTestIds.colorItem}
    >
      <div className={classes.container}>
        <IconColor fill={colorHex} />
        <Text
          weight={FontWeights.medium}
          size={TypographyT5}
          color={PositiveColors.text.default}
          data-name="colors"
        >
          {translate(color?.label)}
        </Text>
      </div>
    </Button>
  );
};

export default ColorItem;
